import React from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import "./NotFound.css";

function NotFound() {
  return (
    <>
      <Helmet>
        <title>404 — Page Not Found | AxiomLabs Solutions</title>
        <meta
          name="description"
          content="The page you're looking for doesn't exist. Head back to AxiomLabs Solutions to browse our products and guides."
        />
      </Helmet>
      <div className="notfound-page">
        <div>
          <p className="notfound-page__code">404</p>
          <h1 className="notfound-page__title">Page Not Found</h1>
          <p className="notfound-page__text">
            The page you're looking for doesn't exist or has been moved. Head
            back to explore our tools and guides.
          </p>
          <div className="notfound-page__actions">
            <Link to="/" className="notfound-page__link notfound-page__link--primary">
              <span>Go Home</span>
              <span>→</span>
            </Link>
            <Link to="/products" className="notfound-page__link notfound-page__link--secondary">
              <span>View Products</span>
            </Link>
          </div>
        </div>
      </div>
    </>
  );
}

export default NotFound;
